module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "pattern-defs"
    }
  }, [_c('defs', [_vm._l((_vm.modifiers), function(color, modifier) {
    return [_c('pattern', {
      attrs: {
        "id": ("circles-2" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "5",
        "height": "5"
      }
    }, [_c('rect', {
      attrs: {
        "width": "5",
        "height": "5",
        "fill": "#fff",
        "fill-opacity": "0.7"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "cx": "1.5",
        "cy": "1.5",
        "r": "1.5",
        "fill": color
      }
    })]), _vm._v(" "), _c('pattern', {
      attrs: {
        "id": ("circles-5" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "9",
        "height": "9"
      }
    }, [_c('rect', {
      attrs: {
        "width": "9",
        "height": "9",
        "fill": "#fff",
        "fill-opacity": "0.7"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "cx": "3",
        "cy": "3",
        "r": "3",
        "fill": color
      }
    })]), _vm._v(" "), _c('pattern', {
      attrs: {
        "id": ("circles-8" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "10",
        "height": "10"
      }
    }, [_c('rect', {
      attrs: {
        "width": "10",
        "height": "10",
        "fill": "#fff",
        "fill-opacity": "0.7"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "cx": "4.5",
        "cy": "4.5",
        "r": "4.5",
        "fill": color
      }
    })]), _vm._v(" "), _c('pattern', {
      attrs: {
        "id": ("diagonal-stripe-1" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "10",
        "height": "10"
      }
    }, [_c('rect', {
      attrs: {
        "width": "10",
        "height": "10",
        "fill": "#fff",
        "fill-opacity": "0.7"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M-1,1 l2,-2\n                 M0,10 l10,-10\n                 M9,11 l2,-2",
        "stroke": color,
        "stroke-width": "1"
      }
    })]), _vm._v(" "), _c('pattern', {
      attrs: {
        "id": ("diagonal-stripe-4" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "10",
        "height": "10"
      }
    }, [_c('rect', {
      attrs: {
        "width": "10",
        "height": "10",
        "fill": "#fff",
        "fill-opacity": "0.7"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M-1,1 l2,-2\n                 M0,10 l10,-10\n                 M9,11 l2,-2",
        "stroke": color,
        "stroke-width": "3"
      }
    })]), _vm._v(" "), _c('pattern', {
      attrs: {
        "id": ("diagonal-stripe-6" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "10",
        "height": "10"
      }
    }, [_c('rect', {
      attrs: {
        "width": "10",
        "height": "10",
        "fill": color
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M-1,1 l2,-2\n                 M0,10 l10,-10\n                 M9,11 l2,-2",
        "stroke": "white",
        "stroke-width": "1"
      }
    })]), _vm._v(" "), _c('pattern', {
      attrs: {
        "id": ("dots-5" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "10",
        "height": "10"
      }
    }, [_c('rect', {
      attrs: {
        "width": "10",
        "height": "10",
        "fill": "#fff",
        "fill-opacity": "0.7"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "0",
        "y": "0",
        "width": "5",
        "height": "5",
        "fill": color
      }
    })]), _vm._v(" "), _c('pattern', {
      attrs: {
        "id": ("dots-8" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "10",
        "height": "10"
      }
    }, [_c('rect', {
      attrs: {
        "width": "10",
        "height": "10",
        "fill": "#fff",
        "fill-opacity": "0.7"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "0",
        "y": "0",
        "width": "8",
        "height": "8",
        "fill": color
      }
    })]), _vm._v(" "), _c('pattern', {
      attrs: {
        "id": ("crosshatch" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "8",
        "height": "8"
      }
    }, [_c('rect', {
      attrs: {
        "width": "8",
        "height": "8",
        "fill": "#fff",
        "fill-opacity": "0.7"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0 0L8 8ZM8 0L0 8Z",
        "stroke-width": "0.5",
        "stroke": color,
        "stroke-opacity": "0.8"
      }
    })]), _vm._v(" "), _c('pattern', {
      attrs: {
        "id": ("vertical-line" + modifier),
        "patternUnits": "userSpaceOnUse",
        "width": "4",
        "height": "49"
      }
    }, [_c('rect', {
      attrs: {
        "width": "4",
        "height": "50",
        "fill": "#fff",
        "fill-opacity": "0.8"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "width": "2",
        "height": "50",
        "fill": "#fff",
        "fill-opacity": "0.5"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "2",
        "width": "1",
        "height": "50",
        "fill": color,
        "fill-opacity": "0.5"
      }
    })])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58b79196!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Textures.vue
// module id = 680
// module chunks = 2